import { z } from 'zod';
import { IntSchema } from '../../../../react-commons/schemas/integerSchemas';

export const IdSchema = z.guid();

export const NameSchema = z
    .string()
    .min(1);
    // .max(128);

// TODO export const LongNameSchema = z.string().max(500);
//  export const DescriptionSchema = z.string().max(5000);
//  export const ReferenceSchema = IdSchema.nullable();
//  etc.

export const NaturalNumberSchema = IntSchema.nonnegative();

// TODO use or remove all of these
export const UseOrRemoveSchema = z.unknown();

// TODO these properties are unused on the FE, change schema once they are used!
export const UnusedSchema = z.unknown();
